/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { userListConfig } from '../../config/credentialList.config';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { GET_CREDENTIAL_LIST } from '../../api/graphql';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { CREDENTIAL_TYPE } from '@/config/applicationType.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface ICredentialListMethods extends IPluginMethodMap {
  getCredentialList(args: any): Promise<any>;
}

export class CredentialListService implements IAgentPlugin {
  readonly methods: ICredentialListMethods;

  constructor() {
    this.methods = {
      getCredentialList: this.getCredentialList.bind(this),
    };
  }

  private async getCredentialList(args: any) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_CREDENTIAL_LIST, {
          input: {
            skip: args?.offset,
            limit: args?.size || 10,
            where: [
              ...(args?.where ?? []),
              // {
              //   column: 'status',
              //   op: 'In',
              //   value: ['SUBMITTED'],
              // },
            ],
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfCredential?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            data: _rowData,
            //hi
            isEmpty: _rowData
              ? res?.data?.getListOfCredential?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfCredential?.currentPage,
            pageSize: res?.data?.getListOfCredential?.pageSize,
            totalCount: res?.data?.getListOfCredential?.totalCount,
            totalPages: res?.data?.getListOfCredential?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          applicationId: item?.cerdentialNo,
          id: item?.cerdentialNo,
          employer: item?.employer?.name,
          badges: [this.getFormattedStatus(item?.status)],
          listImg: 'WP',
          type: CREDENTIAL_TYPE?.[item?.type],
          appType: item?.type,
          name: item?.issuedTo?.fullName ?? '',
          pdf:item?.pdf,
          verifyLink:item?.verifyLink,
          email: item?.issuedTo?.email,

          validTill: this.formatCreatedDate(item?.validTill),
          validFrom: this.formatCreatedDate(item?.issuanceDate),
          status: this.getFormattedStatus(item?.status)?.title,
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    console.log('ans->', date);
    if (date) {
      const ans = moment(date).format('LLL');
      console.log('ans->', ans);
      return ans;
    }
  }

  private getFormattedStatus(status: string): any {
    if (status) {
      switch (status) {
        case 'ACTIVE':
          return { key: 1, title: 'Active', color: '#00AB08' };
        case 'APPLIED_FOR_RENEWAL':
          return { key: 1, title: 'Applied for Renewal', color: '#ffb700' };
        case 'EXPIRING_SOON':
          return { key: 1, title: 'Expiring Soon', color: '#ffb700' };
        case 'EXPIRED':
          return { key: 1, title: 'Expired', color: '#E3040E' };
        case 'TERMINATED':
          return { key: 1, title: 'Terminated', color: '#E3040E' };
        case 'TERMINATION_REQUESTED':
          return { key: 1, title: 'Termination Requested', color: '#ffb700' };
        default:
          return '-';
      }
    }
  }
}
